export default {
  rooms: state => state.rooms,
  messages: state => state.messages,
  participants: state => state.participants,
  connected: (state) => {
    return !!state.connection // && (state.connectionReadyState === WebSocket.OPEN)
  }
}
